import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { PoModule } from "@po-ui/ng-components";
import { PoTemplatesModule } from "@po-ui/ng-templates";
import { PeriodFilterModule } from "src/app/shared/period/period-filter.module";

import { AreaTribeAdminComponent } from "./area-tribe-admin.component";
import { AccessAuditComponent } from "./access-audit/access-audit.component";
import { StructureComponent } from "./structure/structure.component";
import { TribesComponent } from "./tribes/tribes.component";
import { UserEditComponent } from "./user-edit/user-edit.component";
import { UsersAccessComponent } from "./users-access/users-access.component";
import { AccessAuditService } from "./services/access-audit.service";
import { AccessCatalogService } from "./services/access-catalog.service";
import { AreaService } from "./services/area.service";
import { TribeService } from "./services/tribe.service";
import { UserTransferService } from "./services/user-transfer.service";
import { UsersAccessService } from "./services/users-access.service";

@NgModule({
  declarations: [AreaTribeAdminComponent, UsersAccessComponent, UserEditComponent, StructureComponent, TribesComponent, AccessAuditComponent],
  imports: [CommonModule, PoModule, PoTemplatesModule, FormsModule, RouterModule, PeriodFilterModule],
  exports: [AreaTribeAdminComponent],
  providers: [AreaService, TribeService, UserTransferService, AccessCatalogService, UsersAccessService, AccessAuditService],
})
export class AreaTribeAdminModule {}
